import { render, staticRenderFns } from "./kanban-details.vue?vue&type=template&id=44a3005a&scoped=true&"
import script from "./kanban-details.vue?vue&type=script&lang=js&"
export * from "./kanban-details.vue?vue&type=script&lang=js&"
import style0 from "./kanban-details.vue?vue&type=style&index=0&id=44a3005a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44a3005a",
  null
  
)

export default component.exports